<script setup>
	import { useLocalStorage } from '@/composables/useLocalStorage.js'

	const image = useLocalStorage('__logo', 'img/app-icons/android-chrome-192x192.png')

</script>
<template>
	<div class="rounded-full w-16 h-16 bg-white dark:bg-zinc-700 mt-[-48px] shadow-xl shadow-zinc-400/50 dark:shadow-zinc-900/50 border-4 border-white dark:border-zinc-800 relative">
      <img 
      	class="absolute top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%] rounded-full" 
      	v-lazy="{ 
      		src: image, 
      		loading: 'img/image_loader.gif', 
      		error: 'img/no_image.png' 
      	}" 
      />
    </div>
</template>